'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/secondFromNow.js